import { PlusOutlined } from '@ant-design/icons'
import { Flex, Input, Tag, Tooltip } from 'antd'
import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'

const tagInputStyle = {
  height: 30,
  marginInlineEnd: 8,
  verticalAlign: 'top',
  width: 80,
}

const tagPlusStyle = {
  borderStyle: 'dashed',
  height: 30,
}

const Tags = ({ errors, onChange }) => {
  const [tags, setTags] = useState([])
  const [inputVisible, setInputVisible] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [editInputIndex, setEditInputIndex] = useState(-1)
  const [editInputValue, setEditInputValue] = useState('')

  const inputRef = useRef(null)
  const editInputRef = useRef(null)

  useEffect(() => {
    if (inputVisible) inputRef.current?.focus()
  }, [inputVisible])

  useEffect(() => {
    editInputRef.current?.focus()
  }, [editInputValue])

  useEffect(() => {
    onChange(tags)
  }, [tags])

  useEffect(() => {
    if (tags.length > 0 && errors.length > 0) {
      const filteredTags = tags.filter((tag) => errors.includes(tag))
      setTags(filteredTags)
    }
  }, [errors])

  const handleClose = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag)

    setTags(newTags)
  }

  const showInput = () => {
    setInputVisible(true)
  }

  const handleInputChange = (e) => {
    setInputValue(e.target.value.trim())
  }

  const handleInputConfirm = () => {
    if (inputValue && !tags.includes(inputValue)) {
      setTags([...tags, inputValue])
    } else {
      setInputVisible(false)
    }

    setInputValue('')
  }

  const handleEditInputChange = (e) => {
    setEditInputValue(e.target.value)
  }

  const handleEditInputConfirm = () => {
    const newTags = [...tags]
    newTags[editInputIndex] = editInputValue

    setTags(newTags)
    setEditInputIndex(-1)
    setEditInputValue('')
  }

  return (
    <Flex className="input-tag-list" gap="4px 0" wrap>
      {tags.map((tag, index) => {
        if (editInputIndex === index) {
          return (
            <Input
              key={tag}
              onBlur={handleEditInputConfirm}
              onChange={handleEditInputChange}
              onPressEnter={handleEditInputConfirm}
              ref={editInputRef}
              size="small"
              style={tagInputStyle}
              value={editInputValue}
            />
          )
        }

        const isLongTag = tag.length > 20
        const tagElem = (
          <Tag
            closable
            color={errors.includes(tag) ? 'volcano' : null}
            key={tag}
            onClose={() => handleClose(tag)}
            style={{
              userSelect: 'none',
            }}
          >
            <span
              onDoubleClick={(e) => {
                setEditInputIndex(index)
                setEditInputValue(tag)
                e.preventDefault()
              }}
            >
              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
            </span>
          </Tag>
        )
        return isLongTag ? (
          <Tooltip key={tag} title={tag}>
            {tagElem}
          </Tooltip>
        ) : (
          tagElem
        )
      })}

      {inputVisible ? (
        <Input
          onBlur={handleInputConfirm}
          onChange={handleInputChange}
          onPressEnter={handleInputConfirm}
          ref={inputRef}
          size="small"
          style={tagInputStyle}
          type="text"
          value={inputValue}
        />
      ) : (
        <Tag icon={<PlusOutlined />} onClick={showInput} style={tagPlusStyle}>
          New QR code
        </Tag>
      )}
    </Flex>
  )
}

Tags.propTypes = {
  errors: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default Tags
